import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss']
})
export class CalendarComponent implements OnInit {
  activeTab: string = '2024-25';

  constructor() { }
  ngOnInit(): void { }

  setActiveTab(tab: string) {
    this.activeTab = tab;
  }
}
